import { currencyOptions } from "@/common/const";
import { fieldServiceTypeOptions } from "@/common/const/filter-options";
import fieldServiceHoursOptions from "@/common/const/filter-options/fieldServiceHours.options";
import { FormFieldsStrategyType } from "@/common/types";

const fieldServiceQuoteLineStrategy: FormFieldsStrategyType[] = [
  {
    label: "Currency",
    name: "targetCurrency",
    required: false,
    readonly: true,
    inputType: "select",
    options: currencyOptions,
  },
  {
    inputType: "text",
    label: "OTC",
    name: "targetOTC",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "Quote Type",
    required: false,
    readonly: true,
    name: "quoteType",
  },
  {
    inputType: "text",
    label: "label",
    name: "",
    required: false,
    readonly: true,
    wrapperClassName: "opacity-0 hidden",
  },
  {
    inputType: "select",
    label: "Field Service Type",
    name: "fieldServiceType",
    required: false,
    readonly: true,
    options: fieldServiceTypeOptions,
  },
  {
    inputType: "select",
    label: "Hours Type",
    name: "hoursType",
    required: false,
    readonly: true,
    options: fieldServiceHoursOptions,
  },

  {
    inputType: "text",
    label: "No. of Hours",
    name: "noOfHours",
    required: false,
    readonly: true,
    pattern: /^[2-8]$/,
    errorMessage: "The value must be an integer between 2 and 8.",
  },

  {
    inputType: "text",
    label: "Extra Hours Rate",
    name: "extraHoursRate",
    required: false,
    readonly: true,
  },
  {
    inputType: "text",
    label: "Lead Time (in Days)",
    name: "leadTeam",
    required: false,
    readonly: true,
  },
  {
    inputType: "select",
    label: "Network Status",
    name: "networkStatus",
    required: false,
    readonly: true,
    options: [
      {
        label: "Off Net",
        value: "OfNet",
      },
      {
        label: "Near Net",
        value: "NearNet",
      },
      {
        label: "On Net",
        value: "OnNet",
      },
    ],
  },
  {
    inputType: "textarea",
    label: "Note",
    name: "description",
    required: false,
  },
];
export default fieldServiceQuoteLineStrategy;
